export const environment = {
  production: true,
  BaseUrl: 'https://memorabid.com/',
  APIBaseUrl: "https://backstart.memorabid.com/api/",
  recaptcha: {
    siteKey: '6LfrPlgfAAAAAE1WcS0VWC-rO-YtDrANWhMRdL71',
  },
  APPOrigin: 'https://memorabid.com',
  facebookPixelId: '682934686242366',
  canonicalUrl: 'https://www.memorabid.com/',
  paypalClientId: 'AZ_a3oi6qIlStLSPFbaGl5LjrQ2I43o_qlJPgLw7bjJPl9WImeI2oHCv_58P6Z8iXJdhscKfcaIbiGU6',
  stripePublicKey: 'pk_live_51KW0lyHIg3lbZ0HB0ZP4jY7hocCLPblFr6CPHmaK3BSM1h5ljr2cDmCve2kQ2mAAxrgtn2nlRnua2znPSIhCZ0AI00KDdGsA3s'
};


